import { useIntl } from 'react-intl';

import { useGuidePlay } from '@/hooks/app/useGuidePlay';
import { useProgramInfo } from '@/hooks/app/useProgramInfo';
import { useProgramState } from '@/hooks/store';
import { MeditationType } from '@/store/program/types';

import messages from './messages';
import { PlayButton, TrailerButton, Wrapper } from './styles';

const ProgramPlayActions = () => {
	const onGuidePlay = useGuidePlay();
	const { formatMessage } = useIntl();
	const program = useProgramState();
	const { trailer, guides } = useProgramInfo();

	const hasPlayActions =
		program &&
		([MeditationType.MasterClass, MeditationType.Body] as string[]).includes(program.meditation_type);

	const onPlay = async () => {
		if (!guides || guides.length === 0) {
			return;
		}

		await onGuidePlay(guides[0].id, program);
	};

	const onWatchTrailer = async () => {
		if (!trailer) {
			return;
		}

		await onGuidePlay(trailer.id, program);
	};

	if (!hasPlayActions) {
		return null;
	}

	return (
		<Wrapper>
			<PlayButton onPress={onPlay}>{formatMessage(messages.playButton)}</PlayButton>
			{!!trailer && (
				<TrailerButton onPress={onWatchTrailer}>{formatMessage(messages.watchTrailerButton)}</TrailerButton>
			)}
		</Wrapper>
	);
};

export default ProgramPlayActions;
